<script setup>
import { useCustomFields } from '@/composables/useCustomFields'
const { renderer } = useCustomFields()

const props = defineProps({
    unit: {
        type: Object,
        required: true
    },
    unitStatus: {
        type: Object,
        required: true
    },
    unitThumbnail: {
        type: String,
        required: true
    },
    project: {
        type: Object,
        required: true
    },
    minimumWidth: {
        type: [Number, String],
        default: '250px'
    }
})

const thumbnailImage = computed(() => {
    return props.unitThumbnail
})
</script>
<template>
    <v-card v-if="unit" class="mx-auto unit-card" :min-width="minimumWidth" elevation="0">
        <div v-if="thumbnailImage">
            <img :src="unitThumbnail" :alt="unit.title" class="unit-thumbnail" />
        </div>
        <v-card-text>
            <div class="d-flex justify-space-between align-center">
                <div class="text-subtitle-2 unit-name" :title="unit.title">
                    {{ unit.title }}
                </div>
                <v-chip
                    class="ma-2"
                    size="x-small"
                    :color="unitStatus.textColor"
                    variant="flat"
                    label
                >
                    {{ $getI18n(unitStatus.label) }}
                </v-chip>
            </div>
            <ul class="stats-list">
                <li v-if="unit.size">
                    <span class="font-weight-bold text-capitalize"> {{ $t('area') }}: </span>
                    <span class="ml-1">
                        {{ renderer(project, 'number', 'size', unit.size) }}
                    </span>
                </li>
                <li v-if="!unitStatus.isSold && unit.price">
                    <span class="font-weight-bold text-capitalize"> {{ $t('price') }}: </span>
                    <span class="ml-1">
                        {{ renderer(project, 'currency', 'price', unit.price) }}
                    </span>
                </li>
                <li v-if="unit.rooms">
                    <span class="font-weight-bold text-capitalize"> {{ $t('room') }}: </span>
                    <span class="ml-1">
                        {{ renderer(project, 'number', 'rooms', unit.rooms) }}
                    </span>
                </li>
            </ul>
            <slot></slot>
        </v-card-text>
    </v-card>
</template>
<style scoped>
.stats-list li span {
    font-size: 0.8rem;
}

.unit-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.unit-thumbnail {
    max-width: 100%;
    width: 400px;
    height: auto;
}
</style>
